import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
import React from 'react';
import { Form, Message } from 'semantic-ui-react';
import { submitReview } from './CustomerReview.utils';
import ReSubmitRecaptchaForm from '../../../components/ReSubmitRecaptchaForm';
import { ActionName } from '../../../components/RecaptchaProvider/RecaptchaProvider.constants';
import StarRating from '../../../components/StarRating';
import { Event } from '../../../modules/analytics/components';
import { EVENT_CATEGORIES, EVENT_ACTIONS } from '../../../modules/analytics/components/Event';
import { LocationPropType } from '../../../services/proptypes';
import LocationsSelect from '../../locations/LocationsSelect/LocationsSelect';
import { getPrimaryLocationId } from '../../locations/LocationsSelect/LocationsSelect.utils';
import './CustomerReview.css';
var defaultProps = {
  locations: [],
  showRating: true,
  onSubmitReview: submitReview,
  hideRecaptchaNotice: false
};
var CustomerReview = /*#__PURE__*/function (_React$Component) {
  _inherits(CustomerReview, _React$Component);
  var _super = _createSuper(CustomerReview);
  function CustomerReview(props) {
    var _this;
    _classCallCheck(this, CustomerReview);
    _this = _super.call(this, props);
    var locations = props.locations;
    var primaryLocationId = getPrimaryLocationId(locations);
    _this.state = {
      formData: {
        location: primaryLocationId
      },
      message: '',
      error: false,
      rating: false
    };
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
    _this.onSubmit = _this.onSubmit.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(CustomerReview, [{
    key: "onChange",
    value: function onChange(e, _ref) {
      var name = _ref.name,
        value = _ref.value;
      this.setState(function (prevState) {
        return {
          formData: _objectSpread(_objectSpread({}, prevState.formData), {}, _defineProperty({}, name, value))
        };
      });
    }
  }, {
    key: "onSubmit",
    value: function () {
      var _onSubmit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event, recaptchaToken) {
        var _this$props, businessId, businessType, onSubmitReview, _this$state, formData, rating, validationMessage;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this$props = this.props, businessId = _this$props.businessId, businessType = _this$props.businessType, onSubmitReview = _this$props.onSubmitReview;
              _this$state = this.state, formData = _this$state.formData, rating = _this$state.rating;
              validationMessage = this.getValidationMessage();
              if (!validationMessage) {
                _context.next = 6;
                break;
              }
              this.displayMessage(validationMessage, true, {
                clearTimeout: false
              });
              return _context.abrupt("return");
            case 6:
              _context.prev = 6;
              _context.next = 9;
              return onSubmitReview({
                businessId: businessId,
                businessType: businessType
              }, _objectSpread(_objectSpread({}, formData), {}, {
                rating: rating
              }), recaptchaToken);
            case 9:
              this.resetForm();
              this.displayMessage('Review sent successfully.');
              _context.next = 17;
              break;
            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](6);
              this.displayMessage('Unknown error sending contact form. Please try again later.', true);
              throw _context.t0;
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[6, 13]]);
      }));
      function onSubmit(_x, _x2) {
        return _onSubmit.apply(this, arguments);
      }
      return onSubmit;
    }()
  }, {
    key: "getValidationMessage",
    value: function getValidationMessage() {
      var showRating = this.props.showRating;
      var rating = this.state.rating;
      if (!rating && showRating) {
        return 'To submit your review, please select a star rating for this business';
      }
      return null;
    }
  }, {
    key: "displayMessage",
    value: function displayMessage(messageToDisplay) {
      var _this2 = this;
      var isError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref2$clearTimeout = _ref2.clearTimeout,
        clearTimeout = _ref2$clearTimeout === void 0 ? true : _ref2$clearTimeout;
      this.setState({
        message: messageToDisplay,
        error: isError
      });
      if (clearTimeout) {
        setTimeout(function () {
          _this2.setState({
            message: ''
          });
        }, 5000);
      }
    }
  }, {
    key: "resetForm",
    value: function resetForm() {
      var locations = this.props.locations;
      var primaryLocationId = getPrimaryLocationId(locations);
      this.setState({
        formData: {
          location: primaryLocationId
        },
        rating: false
      });
    }
  }, {
    key: "isFormValid",
    value: function isFormValid() {
      var formData = this.state.formData;
      return !this.getValidationMessage(formData);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props2 = this.props,
        locations = _this$props2.locations,
        showRating = _this$props2.showRating,
        hideRecaptchaNotice = _this$props2.hideRecaptchaNotice;
      var _this$state2 = this.state,
        formData = _this$state2.formData,
        rating = _this$state2.rating,
        error = _this$state2.error,
        message = _this$state2.message;
      return /*#__PURE__*/React.createElement(ReSubmitRecaptchaForm, {
        className: "submit-reviews-form",
        onSubmit: this.onSubmit,
        postSubmissionMessage: "Thank you for letting us know about your experience!",
        postSubmissionButtonMessage: "Submit Another Review",
        action: ActionName.SUBMIT_REVIEW_FORM,
        hideRecaptchaNotice: hideRecaptchaNotice
      }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LocationsSelect, {
        locations: locations,
        onChange: this.onChange
      }), /*#__PURE__*/React.createElement(Form.Input, {
        required: true,
        label: "Name",
        placeholder: "Name",
        value: formData.name || '',
        name: "name",
        onChange: this.onChange
      }), /*#__PURE__*/React.createElement(Form.Field, {
        required: true
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "review-text-area"
      }, "Review"), /*#__PURE__*/React.createElement(StarRating, {
        onChange: function onChange(e, target) {
          _this3.setState({
            rating: target.rating
          });
        },
        value: rating,
        show: showRating
      }), /*#__PURE__*/React.createElement(Form.TextArea, {
        id: "review-text-area",
        placeholder: "Enter your review here",
        value: formData.review || '',
        name: "review",
        onChange: this.onChange,
        required: true
      })), message && /*#__PURE__*/React.createElement(Message, {
        content: message,
        negative: error
      }), /*#__PURE__*/React.createElement(Event, {
        eventType: "click",
        event: {
          category: EVENT_CATEGORIES.REVIEWS_EVENT_CATEGORY,
          action: EVENT_ACTIONS.REVIEWS_SUBMIT_REVIEW_EVENT_ACTION
        }
      }, /*#__PURE__*/React.createElement(Form.Button, {
        disabled: !this.isFormValid(),
        primary: true
      }, "Submit Review"))));
    }
  }]);
  return CustomerReview;
}(React.Component);
export { CustomerReview as default };
CustomerReview.defaultProps = defaultProps;